<template>
  <section class="footer-six common-padding">
    <div class="footer-six-bg">
      <img src="@/assets/img/footer-six-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="footer-six-top">
        <div class="row">
          <div class="col-lg-2 col-md-6 col-sm-12">
            <div class="footer-six-top-list">
              <h4>Network</h4>
              <ul>
                <li><a href="javascript:void(0);">Browse by Make</a></li>
                <li><a href="javascript:void(0);">Add Car</a></li>
                <li><a href="javascript:void(0);">Sitemap</a></li>
                <li><a href="javascript:void(0);">My Favourite</a></li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 col-sm-12">
            <div class="footer-six-top-list">
              <h4>Company</h4>
              <ul>
                <li><router-link to="about">About us</router-link></li>
                <li><router-link to="contact">Contact</router-link></li>
                <li><router-link to="contact">Testimonials</router-link></li>
                <li><router-link to="blog-grid">Blog</router-link></li>
                <li><router-link to="signup">Become a dealer</router-link></li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-6 col-sm-12">
            <div class="footer-six-top-list">
              <h4>Help Center</h4>
              <ul>
                <li><router-link to="faq">Faq’s</router-link></li>
                <li><router-link to="pricing">Pricing Plan</router-link></li>
                <li>
                  <router-link to="privacy-policy">Privacy Policy</router-link>
                </li>
                <li>
                  <router-link to="terms-condition"
                    >Terms & Conditions</router-link
                  >
                </li>
                <li><router-link to="howitworks">How it works</router-link></li>
              </ul>
            </div>
          </div>
          <div class="col-lg-6 col-sm-12">
            <div class="footer-six-right">
              <div class="footer-send-mail">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Subscribe to Get Updates"
                />
                <a href="javascript:void(0);">Send mail</a>
              </div>
            </div>
            <div class="social-icon-six">
              <h3>Follow us on</h3>
              <ul>
                <li>
                  <a href="javascript:void(0);" target="_blank"
                    ><i class="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" target="_blank"
                    ><i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" target="_blank"
                    ><i class="fab fa-instagram"></i
                  ></a>
                </li>
                <li>
                  <a href="javascript:void(0);" target="_blank"
                    ><i class="fab fa-linkedin-in"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-six-center">
        <div class="footer-six-center-content">
          <h6>Our Total Visitors</h6>
          <a href="javascript:void(0);">4,56,6597</a>
        </div>
        <div class="footer-six-center-content">
          <h6>Need live support?</h6>
          <a href="javascript:void(0);">listee@example.com</a>
        </div>
        <div class="footer-six-center-content">
          <h6>Toll Free Customer Care</h6>
          <a href="javascript:void(0);">+91 26447 99875</a>
        </div>
        <div class="footer-six-center-list">
          <ul>
            <li><router-link to="index-6"> Home</router-link></li>
            <li><a href="javascript:void(0);"> Site Map</a></li>
            <li>
              <router-link to="privacy-policy"> Privacy policy</router-link>
            </li>
            <li>
              <router-link to="privacy-policy"> Cookie Policy</router-link>
            </li>
          </ul>
        </div>
      </div>
      <hr class="custom-line mb-0" />
      <div class="footer-six-bottom">
        <p>© 2023 Listee. All Rights Reserved.</p>
      </div>
    </div>
  </section>
</template>
